var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33432 2.99997C9.33432 4.35904 8.10796 5.53456 6.49971 5.53456C4.89145 5.53456 3.66509 4.35904 3.66509 2.99997C3.66509 1.64091 4.89145 0.465385 6.49971 0.465385C8.10796 0.465385 9.33432 1.64091 9.33432 2.99997Z",
    stroke: "#4F4F4F",
    strokeWidth: 0.930769
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45579 11.0941C1.78099 9.51736 2.41213 8.64524 3.22095 8.14613C4.05324 7.63255 5.14845 7.46548 6.5 7.46548V6.53471C5.10155 6.53471 3.79051 6.70096 2.73217 7.35404C1.65037 8.02159 0.906512 9.14945 0.544209 10.906L1.45579 11.0941ZM12.4558 10.906C12.0935 9.14945 11.3496 8.02159 10.2678 7.35404C9.20949 6.70096 7.89845 6.53471 6.5 6.53471V7.46548C7.85155 7.46548 8.94676 7.63255 9.77905 8.14613C10.5879 8.64524 11.219 9.51736 11.5442 11.0941L12.4558 10.906Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.a4759574b335e76d6b05fb1ed7704588.svg";
export { ForwardRef as ReactComponent };